module.exports = __webpack_public_path__ + "static/media/gryphon_musee_urbanlandscape_2.86216fd5.jpg";